import { alpha } from '@material-ui/core/styles';
import { css, styled } from '../../../core/theme/styled';

export const StyledContainer = styled.div`
  flex: 1;
`;

type ElementProps = {
  visible: boolean;
};

const sharedStyles = css<ElementProps>`
  display: block;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  pointer-events: none;
  position: sticky;
  transition: opacity 0.2s;
  z-index: 10;
  height: 60px;
  margin-top: -60px;
`;

export const GradientListBottom = styled.div<ElementProps>`
  ${sharedStyles}
  background: ${({ theme }) =>
    `linear-gradient(${alpha(theme.configuration.backgroundColor, 0.01)}, ${
      theme.configuration.backgroundColor
    } 95%)`};
  bottom: -1px;
  width: 100%;

  @media ${(props) => props.theme.device.mobileL} {
    height: 80px;
    margin-top: -80px;
  }
`;

export const GradientListTop = styled.div<ElementProps>`
  ${sharedStyles}
  border-top: 1px solid ${({ theme, visible }) =>
    visible ? alpha(theme.configuration.primaryTextColor, 0.1) : 'transparent'};
  top: 0;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
`;
